// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","mapContainer":"App_mapContainer__3SUeY","buttonContainer":"App_buttonContainer__27BQd","categoryMenuContainer":"App_categoryMenuContainer__2xc9I"};